import { DataModel, Money } from "../../base/index.js";
import type { ContractItemData } from "../ContractItem/index.js";
import type { ContractArticleData } from "../ContractArticle/index.js";
import { DateTime } from "luxon";
import { Project } from "../../project/index.js";

export class AdditionalItem extends DataModel<ContractItemData> {
  public readonly id: string;
  public readonly totalPrice: Money;
  public readonly description: string;
  public readonly articles: ContractArticleData[];
  public readonly activationDate?: DateTime;
  public readonly project?: Project;
  public readonly articleName: string;

  public constructor(data: ContractItemData) {
    super(data);
    this.id = data.itemId;
    this.totalPrice = Money({
      amount: data.totalPrice.value,
      currency: "EUR",
    });
    this.description = data.description;
    this.articles = data.articles;
    if (data.activationDate) {
      this.activationDate = DateTime.fromISO(data.activationDate);
    }
    if (data.groupByProjectId) {
      this.project = Project.ofId(data.groupByProjectId);
    }
    this.articleName = this.articles[0]?.name ?? "";
  }
}
